<div class="w-full">
  <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
    <h6 mat-dialog-title class="font-semibold primary-font">{{'text.check.availability' | translate}}</h6>
    <div class="flex items-center mr-1">
      <span mat-dialog-close class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </span>
    </div>
  </div>
  <div class="flex content-height">
    <!-- Left Side (Timezone, Duration, Calendar, Teams) -->
    <div class="w-2/5 border-r ">
      <div class="flex flex-col content-height overflow-auto zuper-scrollbar">
        <div>
          <div class="flex items-center justify-between pt-2 px-4 ">
            <!-- Left Side: Current Month -->
            <div class="relative cursor-pointer" (click)="openDatePicker()">
              <h2 class="text-lg text-gray-700 font-semibold"> <i
                  class="text-xl ti ti-calendar text-gray-400 mr-2"></i>{{ getMonthYear() }} <i
                  class="text-base ti ti-chevron-down"></i></h2>

              <div>
                <input matInput [min]="today" [matDatepicker]="selectDateRange"
                  class="absolute top-6 left-0 w-0 h-0 opacity-0" (dateChange)="onDateSelect($event)" />
                <mat-datepicker #selectDateRange></mat-datepicker>
              </div>
            </div>
            <!-- Right Side: Prev / Next Buttons -->
            <div class="flex space-x-2">
              <button (click)="prevWeek()" class="w-6 h-6 rounded-full text-gray-400 hover:text-gray-700">
                <i class="ti ti-chevron-left text-2xl"></i>
              </button>
              <button (click)="nextWeek()" class="w-6 h-6 rounded-full text-gray-400 hover:text-gray-700">
                <i class="ti ti-chevron-right text-2xl"></i>
              </button>
            </div>
          </div>
          <!-- Week Days Selector -->
          @if(weekDays.length){
          <div class="flex gap-5 py-2 px-4 overflow-auto zuper-scrollbar">
            @for(obj of weekDays.slice(currentStartIndex, currentEndIndex); track $index){
            <div (click)="!obj?.allow_job || selectDate(obj)"
              [title]="obj?.isHoliday ? 'Holiday - ' + obj?.holidayName : ''"
              [class.border-blue-500]="isSelectedDate(obj.date)" [class.text-blue-500]="obj?.isSlotView"
              [class.bg-gray-100]="obj?.isHoliday" [class.cursor-not-allowed]="!obj?.allow_job"
              class="flex flex-col items-center p-2 w-day-card cursor-pointer border rounded-lg">
              @if(obj?.isHoliday){
              <span class="text-gray-400"
                [ngClass]="{'text-blue-500': obj?.isSlotView && obj?.allow_job , 'text-gray-400': !(obj?.isSlotView && obj?.allow_job)}">{{
                obj.dayValue
                }}</span>
              <span class="mt-2 font-semibold"
                [ngClass]="{'text-blue-500': obj?.isSlotView && obj?.allow_job , 'text-gray-400': !(obj?.isSlotView && obj?.allow_job)}">{{
                obj.dateValue }}</span>
              }@else{
              <span [class.text-blue-500]="obj?.isSlotView || isSelectedDate(obj.date)">{{
                obj.dayValue }}</span>
              <span class="mt-2 font-semibold" [class.text-blue-500]="obj?.isSlotView || isSelectedDate(obj.date)">{{
                obj.dateValue }}</span>
              }
            </div>
            }
          </div>
          }@else{
          <div class="flex gap-5 py-2 px-4 overflow-auto zuper-scrollbar">
            @for(i of [1, 2, 3, 4, 5]; track $index){
            <div class="flex flex-col items-center h-day-card w-day-card cursor-pointer border rounded-lg">
              <div class="h-full w-20 rounded w-full bg-gray-200 animate-pulse"></div>
            </div>
            }
          </div>
          }
        </div>
        <div class="flex-col gap-2">
          <div class="cursor-pointer" (click)="toggleFilters = !toggleFilters">
            <div class="flex items-center justify-between h-10 text-base px-4 primary-font">
              <div class="flex items-center">
                <i class="ti ti-adjustments-horizontal text-xl mr-2 text-gray-400"></i>
                <span class="text-base font-semibold text-gray-600 primary-font">{{'dispatch.manage_filters.header.text'
                  |
                  translate}}</span>
              </div>
              <button *ngIf="toggleFilters" class="w-6 h-6 rounded-full text-gray-400 hover:text-gray-700">
                @if(toggleFilters){
                <i class="ti ti-chevron-up text-2xl"></i>
                } @else{
                <i class="ti ti-chevron-down text-2xl"></i>
                }
              </button>
            </div>
          </div>
          @if(toggleFilters){
          <div class="relative">
            <!-- Timezone & Duration -->
            <div class="flex items-center justify-between w-full px-4" *ngIf="isTimeZoneEnabled">
              <div class="flex relative inline-block w-auto text-base primary-font rounded mt-1">
                <div class="flex items-center">
                  <i class="ti ti-world text-xl text-gray-400"></i>
                  <!-- Button to open dropdown -->
                  <button (click)="searchQuery='';" variant="outline" [brnMenuTriggerFor]="timezoneMenu" hlmBtn
                    [ngClass]="{'border-gray-300': openMenusDropdown === 'TIMEZONE'}"
                    class="custom-dropdown-menu font-medium primary-font w-auto flex text-base gap-1 text-gray-700  px-2 py-2 rounded-md border border-transparent hover:border-gray-300  group transition-all duration-200">
                    <span class="truncate w-auto text-left overflow-hidden text-ellipsis whitespace-nowrap">
                      {{ selectedTimezone?.display_name }}
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0l-4.25-4.25a.75.75 0 01.02-1.06z"
                        clip-rule="evenodd" />
                    </svg>
                  </button>
                </div>

                <ng-template #timezoneMenu>
                  <hlm-menu class="max-w-96 min-w-60">
                    <hlm-menu-group>
                      <div
                        class="h-10 m-2 rounded-md p-0 bg-gray-50 border border-[#E8EDF1] focus-within:border focus-within:border-indigo-500">
                        <i class="ti ti-search text-2xl text-gray-300 px-2"></i>
                        <input placeholder="{{'text.search' | translate}}" [(ngModel)]="searchQuery"
                          class="h-10 text-lg text-color-normal" (ngModelChange)="filterTimeZones()" />
                      </div>
                      <div class="flex flex-col max-h-96 overflow-auto settings-scroll w-full"
                        menuTriggerRestrictOnKeydown [isMenu]="true">
                        <div *ngFor="let timezone of filteredTimeZones">
                          <label hlmMenuItem
                            class="flex cursor-pointer hover:bg-[#F5F7F9] rounded-md mb-1 mx-0 px-2 py-1"
                            (click)="onTimezoneSelect(timezone)">
                            <div class="flex justify-start truncate items-center py-0 px-1 text-color-normal">
                              <div class="pl-3 text-lg text-start">{{timezone.display_name | translate}}</div>
                            </div>
                            <i *ngIf="selectedTimezone?.key === timezone?.key"
                              class="ti ti-check text-2xl text-color-copy ml-auto"></i>
                          </label>
                        </div>
                        @if(filteredTimeZones.length === 0){
                          <div  class="text-base text-color-light mt-4 mb-2 text-center">
                            {{'text.no.filters.found' | translate: {filter: 'timezone'} }}
                          </div>
                        }
                      </div>
                    </hlm-menu-group>
                  </hlm-menu>
                </ng-template>
              </div>
            </div>
            <div
              class="flex items-center justify-between relative inline-block h-10 w-auto text-base primary-font px-4 rounded">
              <div class="flex items-center">
                <i class="ti ti-clock text-xl mr-2 text-gray-400"></i>
                <label class="text-base font-semibold text-gray-600 primary-font items-center">
                  {{'route.label.duration' | translate}}
                </label>
                <div class="flex items-center" *ngIf="getTotalDuration() > 480">
                  <i class="ti ti-alert-circle text-lg mb-1 ml-1 primary-font text-red-500 font-normal"
                    title="{{'text.scheduling.duarion.warning' | translate}}"></i>
                </div>
              </div>
              <div class="flex gap-1">
                <div class="flex items-center gap-1">
                  <input type="text" id="hours" name="hours" [(ngModel)]="duration.hours" autocomplete="off"
                    (keypress)="allowOnlyHours($event)" (input)="onInputChange()" placeholder="0"
                    (blur)="setDefaultValue('hours')"
                    class="w-8 hover-padding text-right h-8 text-base primary-font p-2 pr-0 rounded-md border border-transparent hover:border-gray-300 transition-all duration-200 custom-input-padding focus:border-gray-300"
                    [ngClass]="{'border-red-500 hover:border-red-500 input-padding custom-error-border': getTotalDuration() > 480}" />
                  <span class="text-base mt-0.5 primary-font font-medium text-gray-500"
                    *ngIf="parseNumber(duration.hours) > 1">{{'label.hours' | translate}}</span>
                  <span class="text-base mt-0.5 primary-font font-medium text-gray-500"
                    *ngIf="parseNumber(duration.hours) === 1 || parseNumber(duration.hours) === 0">{{'label.hour' |
                    translate}}</span>
                </div>
                <div class="flex items-center gap-1">
                  <input type="text" id="mins" name="mins" [(ngModel)]="duration.mins" (blur)="setDefaultValue('mins')"
                    (keypress)="allowOnlyMinutes($event)" (input)="onInputChange()" placeholder="00" autocomplete="off"
                    class="w-8 hover-padding text-right h-8 text-base primary-font p-2 pr-0 rounded-md border border-transparent hover:border-gray-300 transition-all duration-200 custom-input-padding focus:border-gray-300"
                    [ngClass]="{'border-red-500 hover:border-red-500 custom-mins-padding custom-error-border pl-0.5': getTotalDuration() > 480 || parseNumber(duration.mins) > 60}" />
                  <span
                    class="text-base mt-0.5 primary-font font-medium text-gray-500">{{'users.preview.work_hours.mins.label'
                    | translate}}</span>
                </div>
              </div>
            </div>
            <div class="flex items-center justify-between h-10 text-base px-4 primary-font">
              <div class="flex items-center">
                <i class="ti ti-users text-xl mr-2 text-gray-400"></i>
                <span class="text-base font-semibold text-gray-600 primary-font">{{'consider_user_shifts.label' |
                  translate}}</span>
              </div>
              <label class="inline-flex items-center cursor-pointer">
                <input type="checkbox" id="considerUserShifts" name="considerUserShifts"
                  (change)="callAssistedScheduleAPI()" [(ngModel)]="assistedScheduleModel.considerUserShifts"
                  class="hidden peer">
                <div
                  class="relative w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[1px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#1A237E]">
                </div>
              </label>
            </div>
            <div
              class="flex items-center justify-between relative inline-block h-10 px-4 w-auto text-base primary-font rounded">
              <div class="flex items-center">
                <i class="ti ti-map text-xl mr-2 text-gray-400"></i>
                <label class="text-base font-semibold text-gray-600 primary-font items-center">
                  {{'dispatch.filter.service_territory.label' | translate}}
                </label>
              </div>
              <!-- Button to open dropdown -->
              @if(selectedTerritories.length > 0){
              <button (click)="searchQuery='';" variant="outline" [brnMenuTriggerFor]="territoryMenu" hlmBtn
                class="custom-dropdown-menu flex items-center font-medium primary-font w-auto text-base gap-1 text-gray-700 px-2 h-8 rounded-md border border-transparent hover:border-gray-300 group transition-all duration-200">
                <span class="truncate w-auto overflow-hidden text-ellipsis whitespace-nowrap">
                  {{ territoryDisplayText }}
                </span>
              </button>
              } @else{
              <div [brnMenuTriggerFor]="territoryMenu" (click)="searchQuery='';">
                <span
                  class="text-gray-400 overflow-hidden hover:text-gray-600 cursor-pointer px-1 h-8 text-ellipsis whitespace-nowrap">
                  {{'text.job.add.territory' | translate}}
                </span>
              </div>
              }
              <ng-template #territoryMenu>
                <hlm-menu class="max-w-96 min-w-60">
                  <hlm-menu-group>
                    <div
                      class="h-10 m-2 rounded-md p-0 bg-gray-50 border border-[#E8EDF1] focus-within:border focus-within:border-indigo-500">
                      <i class="ti ti-search text-2xl text-gray-300 px-2"></i>
                      <input placeholder="{{'text.search' | translate}}" [(ngModel)]="searchQuery"
                        class="h-10 text-lg text-color-normal" (ngModelChange)="filterServiceTerritory()" />
                    </div>
                    <div class="flex flex-col max-h-96 overflow-auto settings-scroll w-full"
                      menuTriggerRestrictOnKeydown [isMenu]="true">
                      <div *ngFor="let territory of filteredServiceTerritories">
                        <label hlm class="flex cursor-pointer hover:bg-[#F5F7F9] rounded-md mb-1 mx-0 px-2 py-1">
                          <hlm-checkbox class="rounded border border-gray-400 h-5 w-5 mt-1"
                            [(ngModel)]="selectedTerritoriesMap[territory?.territory_uid]"
                            (ngModelChange)="onTerritorySelect(territory)" />
                          <div class="flex justify-start truncate items-center py-0 px-1 text-color-normal">
                            <div class="pl-3 text-lg text-start">{{territory.territory_name | translate}}</div>
                          </div>
                        </label>
                      </div>
                      @if(filteredServiceTerritories.length === 0){
                        <div  class="text-base text-color-light mt-4 mb-2 text-center">
                          {{'text.no.filters.found' | translate: {filter: 'territories'} }}
                        </div>
                      }
                    </div>
                  </hlm-menu-group>
                </hlm-menu>
              </ng-template>
            </div>
            <div
              class="flex items-center justify-between h-10 relative inline-block w-full px-4 text-base primary-font rounded">
              <div class="flex items-center">
                <i class="ti ti-tool text-xl mr-2 text-gray-400"></i>
                <label class="text-base font-semibold text-gray-600 primary-font items-center">
                  {{'text.skills' | translate}}
                </label>
              </div>
              <!-- Button to open dropdown -->
              @if(!selectedSkill){
              <div [brnMenuTriggerFor]="skillMenu" (click)="searchQuery='';">
                <span
                  class="text-gray-400 overflow-hidden hover:text-gray-600 px-1 h-8 cursor-pointer text-ellipsis whitespace-nowrap">
                  {{'text.job.add.skill' | translate}}
                </span>
              </div>
              }
              @if(selectedSkill?.skillset_uid){
              <button variant="outline" [brnMenuTriggerFor]="skillMenu" hlmBtn (click)="searchQuery='';"
                class="custom-dropdown-menu flex items-center font-medium primary-font w-auto text-base gap-1 text-gray-700 px-2 h-8 rounded-md border border-transparent hover:border-gray-300  group transition-all duration-200">
                <span class="truncate w-auto overflow-hidden text-ellipsis whitespace-nowrap">
                  {{ selectedSkill?.skillset_name || selectedSkill}}
                </span>
                <i class="ti ti-x text-base font-semibold text-red-300 ml-0.5 hover:text-red-600"
                  (click)="removeSkillset()"></i>
              </button>
              }

              <ng-template #skillMenu>
                <hlm-menu class="max-w-96 min-w-60">
                  <hlm-menu-group>
                    <div
                      class="h-10 m-2 rounded-md p-0 bg-gray-50 border border-[#E8EDF1] focus-within:border focus-within:border-indigo-500">
                      <i class="ti ti-search text-2xl text-gray-300 px-2"></i>
                      <input placeholder="{{'text.search' | translate}}" [(ngModel)]="searchQuery"
                        class="h-10 text-lg text-color-normal" (ngModelChange)="filterSkills()" />
                    </div>
                    <div class="flex flex-col max-h-96 overflow-auto settings-scroll w-full"
                      menuTriggerRestrictOnKeydown [isMenu]="true">
                      <div *ngFor="let skill of filteredSkills">
                        <label hlmMenuItem class="flex cursor-pointer hover:bg-[#F5F7F9] rounded-md mb-1 mx-0 px-2 py-1"
                          (click)="onSkillSelect(skill)">
                          <div class="flex justify-start truncate items-center py-0 px-1 text-color-normal">
                            <div class="pl-3 text-lg text-start">{{skill.skillset_name | translate}}</div>
                          </div>
                          <i *ngIf="selectedSkill?.skillset_uid === skill?.skillset_uid"
                            class="ti ti-check text-2xl text-color-copy ml-auto"></i>
                        </label>
                      </div>
                      @if(filteredSkills.length === 0){
                        <div class="text-base text-color-light mt-4 mb-2 text-center">
                          {{'text.no.filters.found' | translate: {filter: 'skills'} }}
                        </div>
                      }
                    </div>
                  </hlm-menu-group>
                </hlm-menu>
              </ng-template>
            </div>
          </div>
          }
        </div>
        <!-- Teams -->
        <div class="py-4 px-4 border-t  border-b border-gray-300 bg-white">
          <div class="flex items-center">
            <i class="ti ti-users text-xl mr-2 text-gray-400"></i>
            <label class="text-base text-gray-600">
              <span class="font-semibold">{{'text.teams' | translate}}</span>
              <span *ngIf="isTimeZoneEnabled">{{'text.in' | translate}}{{selectedTimezone?.display_name}}</span>
           </label>
          </div>
          <div class="flex  mt-2  gap-4">
            <label class="flex items-center gap-3 flex-1 p-3 border cursor-pointer rounded-lg hover:border-blue-500"
              [ngClass]="{'border-blue-500 bg-blue-50': assistedScheduleModel.teamsType === 'ANY'}">
              <input type="radio" name="team" value="ANY" [ngModelOptions]="{standalone: true}"
                (change)="changeTeamsType('ANY');" [(ngModel)]="assistedScheduleModel.teamsType"
                class="w-4 h-4 text-blue-600 focus:ring-blue-500" />
              <div class="flex items-center">
                <span class="font-medium text-base text-gray-600 primary-font">
                  {{'text.team.any' | translate}}
                </span>
              </div>
            </label>
            <label class="flex items-center gap-3 flex-1 p-3 border cursor-pointer rounded-lg hover:border-blue-500"
              [ngClass]="{'border-blue-500 bg-blue-50': assistedScheduleModel.teamsType === 'SELECTED'}">
              <input type="radio" name="team" value="SELECTED" [ngModelOptions]="{standalone: true}"
                (change)="changeTeamsType('SELECTED');" [(ngModel)]="assistedScheduleModel.teamsType"
                class="w-4 h-4 text-blue-600 focus:ring-blue-500 text-base primary-font" />
              <div class="flex items-center">
                <span class="font-medium text-base text-gray-600 primary-font">{{'text.selected_teams' |
                  translate}}</span>
              </div>
            </label>
          </div>
          <div class="flex mt-2 items-center relative" *ngIf="assistedScheduleModel.teamsType === 'SELECTED'">
            <i
              class="ti ti-search text-2xl text-gray-900 cursor-pointer absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"></i>
            <input type="text" placeholder="{{'teams.table.search_place_holder' | translate}}" [(ngModel)]="searchTeam"
              autocomplete="off" (input)="filterTeams()"
              class="text-lg block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500" />
            <button *ngIf="searchTeam" (click)="clearTeamSearch()"
              class="filter-search-clear absolute right-4 top-1/2 pb-1 w-8 h-8 transform -translate-y-1/2 text-gray-500 hover:text-black hover:bg-gray-100 rounded-full">
              ✕
            </button>
          </div>
        </div>
        <div class="bottom zuper-scrollbar">
          <div *ngIf="assistedScheduleModel.teamsType === 'SELECTED'" class="space-y-2">
            <!-- Team Item -->
            @if(!loadingTeams){
            @for( team of filteredTeams; track i){
            <div class="flex items-center gap-3 py-2 px-4 cursor-pointer"
              [ngClass]="{'border-b': i !== filteredTeams?.length - 1, 'cursor-not-allowed opacity-80': team?.not_allow_job}"
              (click)="!team?.not_allow_job && toggleTeamSelection(team, teamsCheckbox)">
              <input type="checkbox" #teamsCheckbox [checked]="selectedTeamsArr.includes(team?.team_uid)"
                class="w-4 h-4 text-blue-500 border-gray-300 rounded focus:ring-blue-500"
                [disabled]="team?.isHoliday && team?.not_allow_job">
              <div class="flex items-center gap-2 w-full overflow-hidden" [title]="team.team_name">
                <span
                  class="w-8 h-7 flex items-center justify-center text-base primary-font font-medium text-white rounded-full"
                  [style.background]="team.team_color || '#94a3b8'">
                  {{ team.team_name.charAt(0) }}</span>
                <div class="flex justify-between w-full overflow-hidden">
                  <div class="w-3/5 truncate">
                    <div class="text-base font-medium text-gray-800 truncate">
                      <span>{{team.team_name}}</span>
                    </div>
                    <div class="text-md text-gray-500" *ngIf="team.user_count > 1">{{team.user_count}} {{'text.users'
                      | translate}}
                    </div>
                    <div class="text-md text-gray-500" *ngIf="team.user_count === 1">{{team.user_count}}
                      {{'reports.details.employee' | translate}}</div>
                  </div>
                  <div class="flex items-center justify-end w-2/5 ml-auto" [title]="team?.holidayName">
                    <span class="text-gray-600 bg-gray-100 p-1 rounded-md text-base primary-font flex items-center"
                      *ngIf="team?.isHoliday">
                      <i class="ti ti-player-pause-filled text-xl mr-2"></i>
                      {{'dispatchBoard.scheduler.holiday.title' | translate}}</span>
                  </div>
                </div>
              </div>
            </div>
            }
            } @else{
            <div class="teams-container-loader flex justify-center items-center">
              <mat-progress-spinner class="self-center justify-self-center mt-8 mb-8" [diameter]="25"
                [mode]="'indeterminate'">
              </mat-progress-spinner>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    <!-- Right Side (Resource View, Slot View, Available Slots) -->
    <div class="w-3/5">
      <div>
        <div class="border-b border-gray-200 flex items-center justify-between">
          <nav class="flex -mb-px ml-4 gap-2" aria-label="Tabs">
            <a *ngFor="let view of slotViewModes"
              class="whitespace-nowrap flex justify-center py-4 px-1 border-b-2 font-medium text-base cursor-pointer col-span-1"
              (click)="changeViewMode(view.type)" [ngClass]="setTabClasses(view.type)">
              {{ view.displayKey | translate }}
            </a>
          </nav>
        </div>
        @if(isLoading){
          <div class="flex justify-center items-center slots-section-heigth">
            <mat-progress-spinner class="self-center justify-self-center mt-8 mb-8" [diameter]="45"
              [mode]="'indeterminate'">
            </mat-progress-spinner>
          </div>
        } @else{
          @if(selectedViewMode === 'SLOT'){
            @if(assistedScheduleModel.teamsType === 'ANY' || (assistedScheduleModel.teamsType === 'SELECTED' &&
            selectedTeamsArr.length > 0)) {
            @if(copyResourceSlots.length > 0){
            <div class="flex flex-col pt-4 slots-section-heigth overflow-y-auto zuper-scrollbar pl-4">
              <div class="mb-4 pr-3" *ngFor="let dates of copyResourceSlots; let i = index">
                <div *ngIf="!dates.isPastDate" class="mb-2 font-medium flex justify-between">{{ dates.date }}
                  <div *ngIf="dates?.isHoliday" class="flex items-center ml-auto" [title]="dates?.holidayName">
                    <span class="text-gray-600 bg-gray-100 p-1 rounded-md text-base primary-font flex items-center">
                      <i class="ti ti-player-pause-filled text-xl mr-2"></i>
                      {{'dispatchBoard.scheduler.holiday.title' | translate}}</span>
                  </div>
                </div>
                <ng-container *ngIf="dates?.slots?.length > 0; else noSlots">
                  @if(dates?.allow_job){
                  <div class="flex flex-wrap items-center py-2 pb-4 gap-4">
                    <button type="button"
                      class="flex text-base justify-center items-center h-10 border border-1 p-2 rounded-lg hover:bg-gray-100"
                      [ngClass]="{
                            'selected-slot-button':
                              selectedSlot?.startTime === slot.start_time && selectedSlot?.endTime === slot.end_time
                          }" *ngFor="let slot of dates.slots; let index = index" (click)="selectSlot('', slot, '')">
                      {{ utilityService.convertBackToTimeWithoutTz(slot.start_time, 'YYYY-MM-DD HH:mm:ss', 'time') }} -
                      {{ utilityService.convertBackToTimeWithoutTz(slot.end_time, 'YYYY-MM-DD HH:mm:ss', 'time') }}
                    </button>
                  </div>
                  } @else{
                  <div class="flex items-center ml-10 mt-2 mb-2">
                    <span>{{ 'scheduler.no_slots_available' | translate }}</span>
                  </div>
                  }
                </ng-container>
                <ng-template #noSlots>
                  <div *ngIf="!dates.isPastDate" class="flex items-center ml-10 mt-2 mb-2">
                    <span>{{ 'scheduler.no_slots_available' | translate }}</span>
                  </div>
                </ng-template>
              </div>
            </div>
            }
            @if(assistedScheduleModel.teamsType === 'ANY' && !copyResourceSlots.length && !isLoading){
            <div class="flex flex-col slots-section-heigth pl-4 items-center justify-center">
              <span>{{ 'scheduler.no_slots_available' | translate }}</span>
            </div>
            }
            } @else{
            <div class="flex flex-col slots-section-heigth pl-4 items-center justify-center"
              *ngIf=" assistedScheduleModel.teamsType === 'SELECTED' && selectedTeamsArr.length === 0 && !isLoading">
              {{'text.assisted.scheduling.select.team.info' | translate}}
            </div>
            }
          } @else if (selectedViewMode === 'RESOURCE') {
          <ng-container *ngIf="assistedScheduleModel.teamsType === 'ANY'; else selectedTeam">
            <div class="flex flex-col pt-4 slots-section-heigth pl-4">
              <div class="relative mr-6">
                <input type="text" id="resourceViewSearch"
                  class="mt-1 mb-3 block w-full rounded-md border border-gray-300 focus:border-blue-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                  placeholder="{{ 'text.search_user' | translate }}" [(ngModel)]="employeeSearchText" autocomplete="off"
                  (input)="employeeSearchChange()">
                <button type="button" mat-icon-button *ngIf="employeeSearchText"
                  class="mat-focus-indicator min-w-3 min-h-3 min-w 3 h-8 w-8 mat-icon-button mat-button-base absolute inset-y-0 right-0 mr-2 mt-2.5"
                  (click)="employeeSearchText = ''; assignSlotViewData()">
                  <em class="ti ti-x close-mark cursor-pointer text-black"></em>
                </button>
              </div>
              @if(object.keys(copyResourceSlots).length > 0){
              <div class="resource-section-heigth overflow-y-auto zuper-scrollbar pr-3">
                @for( user of object.keys(copyResourceSlots); track i){
                <div class="mb-4">
                  <div class="mb-2 font-medium" [title]="allUsers[user]?.first_name + ' ' + allUsers[user]?.last_name">
                    <div class="flex items-center mt-1 w-full"
                      *ngIf="utilityService.hasValidProfilePicture(allUsers[user]?.profile_picture)">
                      <img [src]="allUsers[user]?.profile_picture" alt="Avatar" class="min-w-8  w-8 h-8 rounded-full" />
                      <span class='ml-2 block truncate text-base primary-font font-normal w-3/5'> {{
                        allUsers[user]?.first_name }} {{ allUsers[user]?.last_name }}</span>
                    </div>
                    <div class="flex items-center mt-1 w-full"
                      *ngIf="!utilityService.hasValidProfilePicture(allUsers[user]?.profile_picture)">
                      <div
                        class="flex items-center justify-center h-8 w-8 text-base primary-font rounded-full ring-2 ring-white uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200"
                        title="{{allUsers[user]?.first_name}}">
                        {{allUsers[user]?.first_name?.charAt(0).toUpperCase()}}
                      </div>
                      <span class='ml-2 block truncate text-base primary-font font-normal w-3/5'> {{
                        allUsers[user]?.first_name }} {{ allUsers[user]?.last_name }}</span>
                    </div>
                  </div>
                  <ng-container *ngIf="copyResourceSlots[user].length > 0; else noUserSlots">
                    <div class="flex flex-wrap items-center py-2 pb-4 gap-4">
                      <button type="button"
                        class="flex text-base justify-center items-center h-10 border p-2 border-1 rounded-lg hover:bg-gray-100"
                        [ngClass]="{
                                  'selected-slot-button':
                                    selectedSlot?.startTime === slot.start_time &&
                                    selectedSlot?.endTime === slot.end_time &&
                                    selectedSlot?.userUid === user
                                }" *ngFor="let slot of copyResourceSlots[user]; let index = index"
                        (click)="selectSlot(user, slot, '')">
                        {{ utilityService.convertBackToTimeWithoutTz(slot.start_time, 'YYYY-MM-DD HH:mm:ss', 'time')
                        }} -
                        {{ utilityService.convertBackToTimeWithoutTz(slot.end_time, 'YYYY-MM-DD HH:mm:ss', 'time') }}
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #noUserSlots>
                    <div class="flex items-center ml-10 mt-2 mb-2">
                      <span>{{ 'scheduler.no_slots_available' | translate }}</span>
                    </div>
                  </ng-template>
                </div>
                }
              </div>
              }
              @if(object.keys(copyResourceSlots).length === 0 && employeeSearchText){
              <div class="flex items-center justify-center mt-4 mb-2">
                <span>{{ 'scheduler.no_employee_found_for_keyword' | translate }}
                  '{{employeeSearchText }}'</span>
              </div>
              }
              @if(object.keys(copyResourceSlots).length === 0 && !employeeSearchText){
              <div class="flex slots-section-heigth  items-center text-center justify-center text-base primary-font">
                <span>{{ 'scheduler.no_slots_available' | translate }}</span>
              </div>
              }
            </div>
          </ng-container>
          }
        }
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="flex  space-x-4 justify-end border-t border-gray-300 zuper-dialog-footer">
    <button type="button" mat-stroked-button mat-dialog-close
      class="px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none btn-small">{{'cancel.text'
      | translate}}</button>
    <button type="button" (click)="emitSelectedSlot()" [disabled]="showButtonSpinner"
      class="px-6 items-center py-2 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary btn-small">
      <span *ngIf="!(showButtonSpinner)">{{"scheduler.use_this_schedule" | translate}}</span>
      <mat-progress-spinner *ngIf="showButtonSpinner" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
    </button>
  </div>
</div>

<ng-template #selectedTeam>
  @if(selectedTeamsArr.length > 0 && !isLoading) {
  <div class="flex flex-col pt-4 slots-section-heigth pl-4">
    <div class="relative mr-6">
      <input type="text" id="resourceViewSearch" [(ngModel)]="employeeSearchText" autocomplete="off"
        (input)="filterUsersAndTeams()"
        class="mt-1 mb-3 block w-full rounded-md border border-gray-300 focus:border-blue-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
        placeholder="{{'text.search.user.team' | translate}}">
      <button type="button" mat-icon-button *ngIf="employeeSearchText"
        class="mat-focus-indicator min-w-3 min-h-3 min-w 3 h-8 w-8 mat-icon-button mat-button-base absolute inset-y-0 right-0 mr-2 mt-2.5"
        (click)="employeeSearchText = '';clearTeamAndUserSearch()">
        <em class="ti ti-x close-mark cursor-pointer text-black text-xl"></em>
      </button>
    </div>
    @if(copyResourceSlots.length > 0) {
    <div class="resource-section-heigth overflow-y-auto zuper-scrollbar pr-3">
      <div class="mb-4" *ngFor="let team of copyResourceSlots; let i = index">
        <div class="border border-gray-200 rounded-md">
          <div class="px-2 py-2 text-base primary-font font-semibold border-b border-gray-200">
            <div class="flex items-center justify-between gap-2">
              <div class="flex items-center w-2/3 overflow-hidden" [title]="team?.team_name">
                <span
                  class="min-w-8  w-8 h-8 flex items-center justify-center text-sm font-medium text-white rounded-full"
                  [style.background]="team.team_color || '#94a3b8'">
                  {{ team?.team_name?.charAt(0) }}
                </span>
                <span class="ml-2 text-base font-medium text-gray-800 truncate">{{team?.team_name}}</span>
              </div>
              @if(team?.users?.length > 1) {
              <div class="flex items-center w-1/3 justify-end text-base text-gray-500">
                {{team?.users?.length}}
                {{'text.users' | translate}}
              </div>
              } @else {
              <div class="flex items-center w-1/3 justify-end text-base text-gray-500">
                {{team?.users?.length}}
                {{'reports.details.employee' | translate}}
              </div>
              }
            </div>
          </div>
          @if(team?.users?.length > 0) {
          <div class="p-4">
            @for(user of team.users.slice(0, team.showMoreUsers ? team.users.length : 2); track j) {
            <div class="py-2">
              <div class="mb-2 font-medium" [title]="user?.userObj.first_name + ' ' + user?.userObj.last_name">
                @if(utilityService.hasValidProfilePicture(user?.userObj?.profile_picture)) {
                <div class="flex items-center mt-1 w-full">
                  <img [src]="user?.userObj?.profile_picture" alt="Avatar" class="min-w-8 w-8 h-8 rounded-full" />
                  <span class="ml-2 block truncate text-base primary-font font-normal w-3/5">
                    {{ user?.userObj.first_name }} {{ user?.userObj.last_name }}
                  </span>
                </div>
                } @else {
                <div class="flex items-center mt-1 w-full"
                  [title]="user?.userObj.first_name + ' ' + user?.userObj.last_name">
                  <div
                    class="flex items-center justify-center h-8 w-8 text-base primary-font rounded-full ring-2 ring-white uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200"
                    title="{{currentItem?.reimbursableTo?.name}}">
                    {{ user?.userObj.first_name?.charAt(0).toUpperCase() }}
                  </div>
                  <span class="ml-2 block truncate text-base primary-font font-normal w-3/5">
                    {{ user?.userObj.first_name }} {{ user?.userObj.last_name }}
                  </span>
                </div>
                }
              </div>
              <div class="flex flex-wrap items-center py-2 pb-4 gap-4" [ngClass]="{
                              'border-b border-gray-200': j !== team.users.length - 1 && !(team.showMoreUsers === false && j === 1)
                            }">
                @for(slot of user.slots; track index) {
                <button type="button"
                  class="flex text-base justify-center items-center h-10 border border-1 p-2 rounded-lg hover:bg-gray-100"
                  [ngClass]="{
                              'selected-slot-button': (selectedSlot?.startTime === slot.start_time) &&
                                (selectedSlot?.endTime === slot.end_time) &&
                                (selectedSlot.userUid === user.user_uid)
                            }" (click)="selectSlot(user, slot, team)">
                  {{ utilityService.convertBackToTimeWithoutTz(slot.start_time, 'YYYY-MM-DD HH:mm:ss', 'time') }} -
                  {{ utilityService.convertBackToTimeWithoutTz(slot.end_time, 'YYYY-MM-DD HH:mm:ss', 'time') }}
                </button>
                }
              </div>
            </div>
            }
            @if(team.users.length > 2) {
            @if(team.showMoreUsers) {
            <button type="button" class="text-base primary-font text-gray-500 hover:text-gray-700"
              (click)="toggleShowMore(team)">
              {{ 'text.show.less' | translate }} <i class="ti ti-chevron-up text-xl"></i>
            </button>
            } @else {
            <button type="button"
              class="text-base primary-font flex items-center gap-1 text-gray-500 hover:text-gray-700"
              (click)="toggleShowMore(team)">
              <span>{{ team.users.length - 2 }} {{ 'text.users.more' | translate }}</span>
              <i class="ti ti-chevron-down text-lg"></i>
            </button>
            }
            }
          </div>
          } @else {
          <div class="flex items-center text-center justify-center text-base primary-font p-4">
            <span>{{ 'scheduler.no_slots_available' | translate }}</span>
          </div>
          }
        </div>
        @if(copyResourceSlots.length === 0){
        <div class="flex items-center text-center justify-center text-base primary-font p-4">
          <span>{{'scheduler.no_slots_available' | translate}}</span>
        </div>
        }
      </div>
    </div>
    }

    @if(selectedTeamsArr.length === 0 && !isLoading && !employeeSearchText){
    <div class="flex items-center justify-center mt-4 mb-2">
      <span>{{'scheduler.no_employee_found_for_keyword' | translate}} '{{employeeSearchText}}'</span>
    </div>
    }
  </div>
  }
  @if(selectedTeamsArr.length === 0 && !isLoading && !employeeSearchText){
  <div class="flex flex-col slots-section-heigth pl-4 items-center justify-center">
    {{'text.assisted.scheduling.select.team.info' | translate}}
  </div>
  }
</ng-template>